import { render, staticRenderFns } from "./NgoInfo.vue?vue&type=template&id=3f5564ca&"
import script from "./NgoInfo.vue?vue&type=script&lang=js&"
export * from "./NgoInfo.vue?vue&type=script&lang=js&"
import style0 from "./NgoInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports